// extracted by mini-css-extract-plugin
export default {"loader":"OpenProjectLoadingStyle_loader__1mUOs","content":"OpenProjectLoadingStyle_content__HhdW5","loaderSize":"OpenProjectLoadingStyle_loaderSize__eM4jf"};